import { Lock } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'
import { TEXT_CAPTION } from './recipes'

/**
 * The scope / audit line under every check and search: a lock plus where the lookup ran and
 * that it was audited. Muted by default; pass a text colour to sit on a verdict surface.
 */
export function ScopeLine({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <p
      className={cn(
        'flex items-start gap-1.5 font-medium text-muted-foreground @5xl/humint:text-xs',
        TEXT_CAPTION,
        className
      )}
    >
      <Lock aria-hidden className="mt-0.5 size-3.5 shrink-0" />
      <span className="min-w-0">{children}</span>
    </p>
  )
}
